/**
 * In order to change API just use another module which
 * implements the same interface as cognito
 */
import * as AuthApi from './cognito/cognito';
export default AuthApi;